import React, { useEffect, useState } from 'react';
import { DateRangePicker } from 'rsuite';
import { useObjCommonFilterStore } from 'src/hooks/objCommonFilter';
import { useOrderStore } from 'src/hooks/order';
import moment from 'moment'
import Helper from 'src/helper/Helper';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';
import useReduxState from 'src/hooks/useReduxState';

const OrderAdvanceFilterPopup = (props) => {
    const { SetStatus} = props
    const [{ order_manufacturer_list }, { fetch_manuFacturer_list }, { }] = useOrderStore();
    const defaulDateRange = [null, null];
    const [expectedDateRangeObject, setExpectedDateRangeObject] = useState(defaulDateRange);
    const [customerRequestedDateObject, setCustomerRequestedDateObject] = useState(defaulDateRange);
    const [{ filter_list }, { }, { set_filter_list }] = useObjCommonFilterStore();
    const filterDetail = { manufacturerPartNumber: '', customerPartNumber: "", manufacturerName: "" };
    const [formData, setFormData] = useState(filterDetail)
    const [continuationToken, setContinuationToken] = useReduxState('', 'setContinuationToken');
    const { storageName: { ORDER_PAGE_TOKEN }, avUserInfoData: { currentUser } } = System
    const isCoreUser = currentUser === Constants.siteUser.CORE

    const statusList = {
        R: { id: "R", text: "Order Received", slug: 'OrderReceived' },
        P: { id: "P", text: "Order in Process", slug: 'OrderInProcess' },
        PS: { id: "PS", text: "Partially Shipped", slug: 'PartiallyShipped' },
        S: { id: "S", text: "Shipped", slug: 'Shipped' },
        C: { id: "C", text: "Cancelled", slug: 'Cancelled' }
    };

    const searchList = [
        { key: "orderStatus", searchType: "Order Status", searchKeywordArr: [] },
        { key: "manufacturerPartNumber", searchType: "Manufacturer Part No.", searchKeyword: "" },
        { key: "customerPartNumber", searchType: "Customer Part Number", searchKeyword: "" },
        { key: "manufacturerName", searchType: "Manufacturer", searchKeywordArr: ""},
        { key: "deliveryDate", searchType: "Expected Delivery Date", searchKeyword: "" },
        { key: "scheduleDate", searchType: "Customer Requested Date", searchKeyword: "" }
    ]

    useEffect(() => {
        async function fetchHere() {
            await fetch_manuFacturer_list();
        }
        if (order_manufacturer_list && order_manufacturer_list?.length === 0)
            fetchHere();
    }, []);

    useEffect(() => {
        if (Object.keys(filter_list)?.length > 0) {
            let filterData = filterDetail;
            Object.keys(filter_list).forEach((property) => {
                if(filter_list[property]) {
                    if (filter_list[property].key === 'orderStatus') {
                        filter_list[property].searchKeywordArr?.forEach(ele => {
                            let statusId = Object.values(statusList)?.find(f => f.text.toLocaleLowerCase() === ele.value.toLocaleLowerCase())?.id;
                            filterData[statusId] = statusId;
                        });
                    } else if (filter_list[property].key === 'deliveryDate') {
                        setExpectedDateRangeObject(setInitialDateVal(filter_list[property].searchKeyword))
                    } else if (filter_list[property].key === 'scheduleDate') {
                        setCustomerRequestedDateObject(setInitialDateVal(filter_list[property].searchKeyword))
                    } else {
                        filterData[filter_list[property].key] = filter_list[property].searchKeyword;
                    }
                }
            });
        }
    }, []);

    const setInitialDateVal = (dtObj) => {
        let _dt = dtObj.split("-");
        _dt[0] = new Date(_dt[0]);
        _dt[1] = new Date(_dt[1]);
        return _dt;
    }

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const onValueChange = (field, value) => {
        setFormData({ ...formData, [field]: value })
    }

    const onSelectStatus = (e) => {
        const val = e.target.value;
        if (e.target.checked) {
            setFormData({ ...formData, [val]: val })
        } else {
            let data = { ...formData };
            delete data[val];
            setFormData(data);
        }
    }

    const capitalizeAfterSpace = (str) => {
        let words = str.split(" ");
        
        words = words.map(word => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        });
        
        return words.join(" ");
    }

    const onApplyFilter = async () => {
        let data = formData;
        let orderSearch = {};
        let statusListSel = {};

        setContinuationToken(null)
        localStorage.removeItem(ORDER_PAGE_TOKEN)

        if (JSON.stringify(expectedDateRangeObject) !== JSON.stringify(defaulDateRange))
            data.deliveryDate = setDateForFilter(expectedDateRangeObject);
        if (JSON.stringify(customerRequestedDateObject) !== JSON.stringify(defaulDateRange))
            data.scheduleDate = setDateForFilter(customerRequestedDateObject);

        Object.keys(data).forEach((property) => {
            if (data[property].trim()) {
                let searchObj = searchList.find(f => f.key === property)
                if (searchObj) {
                    searchObj.searchKeyword = data[property].trim();
                    orderSearch[searchObj.key] = searchObj;
                } else {
                    if(statusList[data[property]]?.text) {
                        statusListSel[property] = {value: capitalizeAfterSpace(statusList[data[property]]?.text), label: statusList[data[property]]?.text};
                    }
                }
            }
        });

        if (Object.keys(statusListSel).length > 0) {
            let searchObj = searchList.find(f => f.key === "orderStatus")
            searchObj.searchKeywordArr = Object.values(statusListSel);
            orderSearch[searchObj.key] = searchObj;
        }

        const updatedFilterList = await updateAndFilterFilterList(formData, filter_list, statusListSel);
        
        set_filter_list({ ...updatedFilterList, ...orderSearch });
        onHide();
    }

    const updateAndFilterFilterList = (formData, currentFilterList, statusListSel) => {
        let updatedFilterList = { ...currentFilterList };

        if(Object.keys(statusListSel).length <= 0 && updatedFilterList['orderStatus']) {
            delete updatedFilterList['orderStatus']
        }
    
        Object.keys(formData).forEach(key => {
            if (formData[key] === "" && updatedFilterList[key]) {
                delete updatedFilterList[key];
            } else if (formData[key] !== "" && updatedFilterList[key]) {
                if (updatedFilterList[key] && typeof updatedFilterList[key] === 'object' && !Array.isArray(updatedFilterList[key])) {
                    if (updatedFilterList[key].searchKeyword !== formData[key]) {
                        updatedFilterList = {
                            ...updatedFilterList,
                            [key]: {
                                ...updatedFilterList[key],
                                searchKeyword: formData[key]
                            }
                        };
                    }
                }
            }
        });
    
        return updatedFilterList;
    };

    useEffect(() => {
        if (expectedDateRangeObject[0] !== null)
            setDateForFilter(expectedDateRangeObject);
    }, [expectedDateRangeObject])

    useEffect(() => {
        if (customerRequestedDateObject[0] !== null)
            setDateForFilter(customerRequestedDateObject);
    }, [customerRequestedDateObject])

    const setDateForFilter = (dtObj) => {
        let dt1_frm = moment(dtObj[0]).local().format(Helper.getDatepickerFormat().toUpperCase());
        let dt2_frm = moment(dtObj[1]).local().format(Helper.getDatepickerFormat().toUpperCase());
        let _dt = dt1_frm + ' - ' + dt2_frm;
        return _dt;
    }

    const onExpectedDateRange = (e) => {
        if (e) {
            setExpectedDateRangeObject(e)
        } else {
            setExpectedDateRangeObject(defaulDateRange)
        }
    }
    const onCustomerRequestedRange = (e) => {
        if (e) {
            setCustomerRequestedDateObject(e)
        } else {
            setCustomerRequestedDateObject(defaulDateRange)
        }
    }

    return (
        <>
                <div className=" avnet-modal modal-730">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => { onHide() }}>×</button>
                        <div className="modal-header">
                            <h4 className="modal-title text-center">Filter Orders</h4>
                        </div>
                        <form id="hook-form">
                            <div className="modal-body">
                                <div className="filter-by-status mb-4 border-top-0  pb-3">
                                    <div className="popup-subheader font-apecru font-16 mb-3">FILTER BY ORDER STATUS</div>
                                    <div className="filter-by-status-checkboxes d-flex justify-content-between">
                                        {statusList && Object.keys(statusList).map((v) => (
                                            <section className="form-check form-check-inline sm-custom_checkbox" key={v} >
                                                <input type="checkbox" className="form-check-input" id={statusList[v].id} name={v} value={v} onChange={onSelectStatus} checked={formData[v] ? true : false} />
                                                <label className="form-check-label mt-0" id={statusList[v].id}>{statusList[v].text}</label>
                                            </section>
                                        ))}
                                    </div>
                                </div>
                                <div className='filter-by-status mb-4 border-top-0 pt-0 pb-3'>
                                <div className="row bs5">
                                    <div className="form-group col-4 mb-2 pb-1">
                                        <label htmlFor="usr">Expected Delivery Date</label>
                                        <DateRangePicker
                                            style={{ width: '100% !important' }}
                                            placeholder="Date Range"
                                            onChange={(dates, event) => {
                                                onExpectedDateRange(dates);
                                            }}
                                            value={expectedDateRangeObject}
                                            ranges={[]}
                                            character=" - "
                                            cleanable={false}
                                            format={Helper.getDatepickerFormat()}
                                            editable={false}
                                            className="w-100 datepickerinputdisable"
                                        />
                                    </div>
                                    {isCoreUser && <div className="form-group col-4 mb-2 pb-1">
                                        <label htmlFor="usr">Customer Requested Date Range</label>
                                        <DateRangePicker
                                            style={{ width: '100% !important' }}
                                            placeholder="Date Range"
                                            onChange={(dates, event) => {
                                                onCustomerRequestedRange(dates);
                                            }}
                                            value={customerRequestedDateObject}
                                            ranges={[]}
                                            character=" - "
                                            cleanable={false}
                                            format={Helper.getDatepickerFormat()}
                                            editable={false}
                                            className="w-100 datepickerinputdisable"
                                        />
                                    </div>}
                                </div>
                                </div>
                                

                                <div className="row bs5 mb-5">
                                    {isCoreUser && <div className="form-group col-4">
                                        <label htmlFor="usr">Customer Part Number</label>
                                        <input type="text" className="form-control form-control-sm" id="customerPartNumber" placeholder="Customer Part Number" value={formData.customerPartNumber} onChange={({ target: { value } }) => onValueChange('customerPartNumber', value)} />
                                    </div>}
                                    <div className="form-group col-4">
                                        <label htmlFor="usr">Manufacturer Part Number</label>
                                        <input type="text" className="form-control form-control-sm" id="manufacturerPartNumber" placeholder="Manufacturer Part Number"
                                            value={formData.manufacturerPartNumber} onChange={({ target: { value } }) => onValueChange('manufacturerPartNumber', value)} />
                                    </div>
                                    <div className="form-group col-4">
                                        <label htmlFor="usr">Manufacturer</label>
                                        <div className="selectbox">
                                        <select className="form-control form-control-sm" id="manufacturerName" value={formData.manufacturerName} onChange={({ target: { value } }) => onValueChange('manufacturerName', value)} >
                                            <option value="">Select Manufacturer</option>
                                            {order_manufacturer_list?.length && order_manufacturer_list?.map((v, i) => (
                                                <option key={v.manufacturerCode} value={v.parentManufacturerName}>{v.parentManufacturerName}</option>
                                            ))}
                                        </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer text-center">
                                <button type="button" className="bs5 btn btn-secondary w145" data-dismiss="modal"
                                    onClick={() => { onHide() }}>Close</button>
                                <button type="button" className="bs5 btn btn-primary w145" onClick={onApplyFilter}>Apply filters</button>
                            </div>
                        </form>
                    </div>
                </div>
        </>
    )
}

export default OrderAdvanceFilterPopup;